import { Component } from '@angular/core';
import { OeAppService } from '../shared/oe-app.service';

@Component({
  selector: 'lp2-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
})
export class PreferencesComponent {
  isTwitterError = this.oeApp.getData('twitterError');

  constructor(private oeApp: OeAppService) {}
}



// WEBPACK FOOTER //
// ./ts/app/preferences/preferences.component.ts